module.exports = __webpack_public_path__ + "static/images/icon-192x192.3slEe7a.png";